<template>
  <div class="flex h-full flex-col">
    <div
      class="mb-4 flex flex-col items-center justify-between gap-8 py-2 md:flex-row-reverse"
    >
      <div
        class="flex flex-col items-center justify-between gap-2 md:flex-row"
      >
        <DateFilter v-model="filters" />
      </div>

      <SearchInput v-model="searchRaw" />
    </div>
    <div class="mb-4 flex w-full justify-center"> </div>
    <TransactionsList :transactions="transactions" />
    <div class="mb-4 flex justify-around px-8">
      <BasePagination
        v-model="page"
        :page-count="pageCount"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const searchRaw = ref<string>("")

const search = refDebounced(searchRaw, 750)
const filters = ref({
  start: undefined,
  end: undefined,
})

const { pagination, page, pageCount, resetPagination } =
  usePagination({
    limit: 10,
    count: computed(() => data.value?.count || 0),
  })

watch(
  () => [filters, search],
  () => resetPagination(),
  { deep: true, immediate: true }
)
const query = reactiveComputed(() => ({
  ...filters.value,
  ...pagination.value,
  search: search.value?.trim(),
}))
const { data } = useTransactions(query)

const transactions = computed(() => data.value?.items ?? [])
</script>
